(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cb-region-switcher"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', function (event) {
    var select = event.target.closest('[data-cb-region-select]');
    if (!select) return;
    var form = select.form;
    if (form) form.submit();
  });
  } catch(e) { console.error(e); }
})();

})();
